import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';

import { IconComponent } from '../icon/icon.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'collapsible-section',
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      .collapsible-header {
        cursor: pointer;
      }

      .content-wrapper {
        overflow: hidden;
        margin-top: 20px;
      }
    `,
  ],
  templateUrl: './collapsible-section.component.html',
})
export class CollapsibleSectionComponent {
  isExpanded = signal(true);

  className = input<string>('');
  label = input.required<string>();
  subText = input<string>('');

  toggleCollapse(): void {
    this.isExpanded.update((value) => !value);
  }
}
